<div class="container-fluid">
    <h2 mat-dialog-title>{{data.fileName}}</h2>
    <hr>
    <div class="body"><img [src]="data.src" alt=""></div>
    <div mat-dialog-actions align="end">
        <button mat-raised-button [mat-dialog-close]="true">Close</button>
    </div>
</div>